enum EventEndpoints {
    GET = '/assets/events',
    CREATE = '/assets/events/{id}/clips',
    GET_CLIPS_BY_ID = '/assets/events/{id}/clips',
}

export { EventEndpoints };
